import { ATHLETE_MANAGEMENT_HOST } from '@/constants/url';

/**
 * b2g-athlete-management(association) 서비스는 자체 라우팅을 사용하므로, 로그인 성공 후
 * Studio 전용 온보딩 경로(콜백 URL의 pathname을 `/onboarding`으로 덮어쓰기)를 적용하면 안 된다.
 * platform은 기존과 동일하게 `web`으로 전달받아 idToken을 그대로 넘겨주고,
 * 온보딩 리다이렉트 여부만 콜백 도메인(prd/dev)으로 구분한다.
 *
 * 콜백 URL이 b2g-athlete-management(association) 도메인인지 여부
 */
const isAthleteManagementCallback = (url: URL): boolean =>
  url.hostname === ATHLETE_MANAGEMENT_HOST ||
  url.hostname.endsWith(`.${ATHLETE_MANAGEMENT_HOST}`);

export default isAthleteManagementCallback;
